module.exports = __webpack_public_path__ + "a4c87039fb8df1b4fa2ab25157f0a73c.pdf";